import { UpdateProfileRequestSchema, UpdateProfileResponseSchema } from './update-profile.schema';
/**
 * Update Profile Endpoint Contract
 * Allows authenticated users to update their own profile
 */ export const updateProfileContract = {
    method: 'PATCH',
    path: '/api/v2/profile',
    description: 'Update the authenticated user profile',
    requestSchema: UpdateProfileRequestSchema,
    responseSchema: UpdateProfileResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Invalid request body or validation error',
            401: 'Unauthorized - invalid or missing token'
        }
    }
};

//# sourceMappingURL=update-profile.contract.js.map